import type { RenewalTransaction } from '@policyvision/contracts';
import { ExternalLinkIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useFormatCurrency } from '@/common/hooks/useFormatCurrency';

interface IProps {
  transactions: RenewalTransaction[];
}

const TransactionsList = ({ transactions }: IProps) => {
  const { t } = useTranslation();
  const { formatCurrency } = useFormatCurrency();
  return (
    <ul className="px-5 pb-4 pt-2">
      {transactions.length ? (
        transactions.map((transaction, idx) => (
          <li
            className="flex items-center justify-between font-semibold text-sm text-ring mt-2"
            key={`${transaction.description}-${idx}`}
          >
            {transaction.description}
            <span className="flex items-center font-medium text-md text-black gap-1">
              {transaction.amount
                ? formatCurrency(transaction.amount.toString())
                : ''}
              <a href={transaction.externalLink} target="_blank">
                <ExternalLinkIcon className="stroke-ring w-4" />
              </a>
            </span>
          </li>
        ))
      ) : (
        <li className="text-sm text-ring font-semibold mt-2">
          {t('renewal.analysisTab.noTransactionsFound')}
        </li>
      )}
    </ul>
  );
};

export default TransactionsList;
